import { Icon, MenuItem, PopupMenu } from '@pandiafi/design-system'
import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import LanguageSelector from './components/LanguageSelector'
import { UserMenuButton } from './components/UserMenuButton/UserMenuButton'
import { navbarStyles } from './utils/navbarStyles'
import routePath from '../../router/routePath'

export const ErrorPageNavbar: React.FC = () => {
  const { t } = useTranslation(['common'])
  const [showProfile, setShowProfile] = useState(false)
  const profileRef = useRef<HTMLButtonElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement

      if (
        showProfile &&
        profileRef.current &&
        !profileRef.current.contains(target)
      ) {
        setShowProfile(false)
      }
    }

    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [profileRef, showProfile])

  return (
    <div>
      <nav className={navbarStyles.nav}>
        <div className={classNames(navbarStyles.navItemsLayout, 'justify-end')}>
          <div className="desktop:flex desktop:items-center desktop:space-x-4">
            <div className="hidden desktop:block">
              <LanguageSelector />
            </div>
            <div className={navbarStyles.userMenu}>
              <UserMenuButton
                ref={profileRef}
                expanded={showProfile}
                toggleUserMenu={() => setShowProfile((prev) => !prev)}
                screenReaderHint={t('common:navbar.openProfile')}
              />
              <PopupMenu
                show={showProfile}
                location="bottom-right"
                className="rounded-md bg-white/95 p-2 text-primary text-right"
              >
                <MenuItem
                  small
                  className="bg-transparent"
                  onClick={() => navigate(routePath.logout)}
                >
                  {t('logOut')}
                  <Icon icon="logout" className="ml-1" />
                </MenuItem>

                <div className="desktop:hidden">
                  <LanguageSelector mobile className="mt-4" />
                </div>
              </PopupMenu>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}
